"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _NumberUtils = require("../../../utils/NumberUtils");

var _ColorUtils = require("../../../utils/ColorUtils");

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Small oval badge with a number or short text string in the center.
 * Can also be used as a dot status with optional text label message.
 */
var Badge =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Badge, _React$Component);

  function Badge() {
    _classCallCheck(this, Badge);

    return _possibleConstructorReturn(this, _getPrototypeOf(Badge).apply(this, arguments));
  }

  _createClass(Badge, [{
    key: "isColorAPreset",

    /**
     * Returns true if color is a preset color
     * @param {string} color - color to check
     * @returns {bool} true if color is a preset
     */
    value: function isColorAPreset(color) {
      return !(0, _isUndefined2.default)((0, _find2.default)(Badge.BADGE_COLOR_TYPES, function (presetColor) {
        return presetColor === color;
      }));
    }
    /**
     * Renders badge text (outside of badge)
     * @param {string} text - text label for badge
     * @param {string} textType - primary or secondary label
     * @returns {node} badge text node
     */

  }, {
    key: "renderBadgeText",
    value: function renderBadgeText(text, textType) {
      // Define text style for dot form badge
      var textStyle;

      if (textType) {
        textStyle = "text-".concat(textType); // Render text style as secondary if text is a number
      } else if ((0, _NumberUtils.isFiniteNumber)(text)) {
        textStyle = 'text-secondary';
      } else {
        textStyle = 'text-primary';
      }

      var badgeTextNode = !(0, _isUndefined2.default)(text) ? _react.default.createElement("div", {
        className: (0, _classnames.default)('badge-text', textStyle)
      }, text) : null;
      return badgeTextNode;
    }
  }, {
    key: "getColorStyleProps",
    value: function getColorStyleProps(color, badgeType) {
      var styleProps = {};

      if (this.isColorAPreset(color)) {
        return styleProps;
      } // Tag Type


      if (badgeType === Badge.BADGE_STYLE_TYPES.TAG) {
        if ((0, _ColorUtils.isValidHEXColor)(color)) {
          styleProps.border = "1px solid ".concat((0, _ColorUtils.shadeRGBColor)((0, _ColorUtils.hexToRGB)(color), 0.70));
        } else {
          styleProps.border = "1px solid ".concat(color);
        }

        styleProps.color = color; // Badge Type
        // Dot Type
      } else {
        styleProps.backgroundColor = color;
      }

      return styleProps;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          count = _this$props.count,
          overflowCount = _this$props.overflowCount,
          text = _this$props.text,
          type = _this$props.type,
          textType = _this$props.textType,
          color = _this$props.color,
          props = _objectWithoutProperties(_this$props, ["className", "count", "overflowCount", "text", "type", "textType", "color"]);

      var countOverflow;

      if ((0, _isNumber2.default)(count) && count > overflowCount) {
        countOverflow = "".concat(Number.parseInt(overflowCount, 10), "+");
      }

      var badgeStyle; // Display as tag style if set
      // TODO: In 2.0 User will need to explicitly call which style the want.

      if (type === Badge.BADGE_TYPES.TAG) {
        badgeStyle = Badge.BADGE_STYLE_TYPES.TAG; // Use badge style if count is a number
      } else if ((0, _NumberUtils.isFiniteNumber)(count)) {
        badgeStyle = Badge.BADGE_STYLE_TYPES.BADGE; // Use text tag style if count is not a number
      } else if (!(0, _isUndefined2.default)(count) && !(0, _isEmpty2.default)(count) && !(0, _NumberUtils.isFiniteNumber)(count)) {
        badgeStyle = Badge.BADGE_STYLE_TYPES.TAG; // Use dot style if 'count' prop is not used (default)
      } else {
        badgeStyle = Badge.BADGE_STYLE_TYPES.DOT;
      }

      var badgeClassNames = (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-badge item-align-self-center"), color);
      var styleProps = {};

      if (!this.isColorAPreset(color)) {
        styleProps.backgroundColor = color;
      }

      return _react.default.createElement(_FlexLayout.default, _extends({
        className: badgeClassNames,
        display: "inline-flex",
        itemSpacing: "10px",
        alignItems: "center"
      }, props), _react.default.createElement("div", {
        className: (0, _classnames.default)('badge-count', badgeStyle),
        style: _objectSpread({}, this.getColorStyleProps(color, badgeStyle))
      }, countOverflow || count), this.renderBadgeText(text, textType));
    }
  }]);

  return Badge;
}(_react.default.Component);

exports.default = Badge;
Badge.BADGE_COLOR_TYPES = {
  RED: 'red',
  GREEN: 'green',
  YELLOW: 'yellow',
  BLUE: 'blue',
  GRAY: 'gray',
  DIAGRAM_PURPLE: 'diagram-purple',
  DIAGRAM_AQUA: 'diagram-aqua',
  DIAGRAM_ORANGE: 'diagram-orange',
  DIAGRAM_YELLOW: 'diagram-yellow'
};
Badge.BADGE_TYPES = {
  BADGE: 'badge',
  TAG: 'tag'
};
Badge.BADGE_STYLE_TYPES = {
  BADGE: 'badge-style',
  DOT: 'dot-style',
  TAG: 'tag-style'
};
Badge.defaultProps = {
  color: Badge.BADGE_COLOR_TYPES.GRAY,
  overflowCount: 99,
  type: Badge.BADGE_TYPES.BADGE
};
Badge.propTypes = {
  /**
   * Color of badge can be any string or a color from the
   * following list:
   *   `Badge.BADGE_COLOR_TYPES.RED`,
   *   `Badge.BADGE_COLOR_TYPES.GREEN`,
   *   `Badge.BADGE_COLOR_TYPES.BLUE`,
   *   `Badge.BADGE_COLOR_TYPES.YELLOW`,
   *   `Badge.BADGE_COLOR_TYPES.GRAY`,
   *   `Badge.BADGE_COLOR_TYPES.DIAGRAM_PURPLE`,
   *   `Badge.BADGE_COLOR_TYPES.DIAGRAM_AQUA`,
   *   `Badge.BADGE_COLOR_TYPES.DIAGRAM_ORANGE`,
   *   `Badge.BADGE_COLOR_TYPES.DIAGRAM_YELLOW`
   * Note: It is recommended to use a color from the list unless custom colors are needed in use
   * cases such as charts.
   */
  color: _propTypes.default.oneOfType([_propTypes.default.oneOf([Badge.BADGE_COLOR_TYPES.RED, Badge.BADGE_COLOR_TYPES.GREEN, Badge.BADGE_COLOR_TYPES.BLUE, Badge.BADGE_COLOR_TYPES.YELLOW, Badge.BADGE_COLOR_TYPES.GRAY, Badge.BADGE_COLOR_TYPES.DIAGRAM_PURPLE, Badge.BADGE_COLOR_TYPES.DIAGRAM_AQUA, Badge.BADGE_COLOR_TYPES.DIAGRAM_ORANGE, Badge.BADGE_COLOR_TYPES.DIAGRAM_YELLOW]), _propTypes.default.string]),

  /**
   * Add custom classname.
   *
   * dark-bg - to style font color for use in dark background.
   */
  className: _propTypes.default.string,

  /**
   * This can be a number or a string to be displayed inside the batch.
   * If count isn't used then by default a status dot is shown instead.
   */
  count: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Change display to badge or tag style.
   */
  type: _propTypes.default.oneOf([Badge.BADGE_TYPES.BADGE, Badge.BADGE_TYPES.TAG]),

  /**
   * This is the text label formated on the right of the badge.
   */
  text: _propTypes.default.node,

  /**
   * Text type for dot style badge. Text type can be one of the following:
   *
   * 'primary' - Use for everything except numbers.
   * 'secondary' - Use for displaying numbers only when in dot form
   *   (Except when used in tables).
   */
  textType: _propTypes.default.string,

  /**
   * If count is larger then this value will be displayed with '+' appended
   * to the end.
   */
  overflowCount: _propTypes.default.number
};